import {Order,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {NavLink} from 'react-router-dom';
import {CreatedByProfileFormatter} from '../../../components/CreatedByProfileFormatter.tsx';
import {Stack} from "@mantine/core";

export const Profile = ({record}: { record: Order }) => {

    const informationProperties = [
        {
            label: 'Customer',
            value: record.customerId ? 
                <NavLink to={`/customers/${record.customerId}`}>{record.customerId}</NavLink> :
                <NavLink to={`/customers/${record.customerId}`}>{record.customerId}</NavLink>,
            span: 12,
        }, {
            label: 'Subscription',
            value: <NavLink to={`/customers/${record.customerId}/#subscriptions`}>{record.subscriptionId}</NavLink>,
            span: 12,
        }];

    const metadataProperties = [
        {
            label: 'Created By',
            value: <CreatedByProfileFormatter record={record as any}/>,
            rbac: 'UpdateOrder',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={informationProperties}/>
            <PlatformPropertyCard properties={metadataProperties}/>
        </Stack>
    );

};

